import { Trans, useTranslation } from 'react-i18next';
import FlightStageTable from '../flight-stage-table/flight-stage-table.component';
import { ArrowRightIcon, Container, FlightEvolutionWrapper, NotesWrapper, StagesWrapper } from './flight-prediction-tab.styles';

const FlightPredictionTab = () => {
  const [t] = useTranslation();

  return (
    <Container data-testid='flight-prediction-tab'>
      <NotesWrapper>
        <div>
          <Trans>{t('pages.regional_overview.digital_traps.info_button.predictions.note_1')}</Trans>
        </div>
        <div>
          <Trans>{t('pages.regional_overview.digital_traps.info_button.predictions.note_2')}</Trans>
        </div>
      </NotesWrapper>
      <FlightEvolutionWrapper>
        <div>
          <Trans>{t('pages.regional_overview.digital_traps.info_button.predictions.flight_evolution_stages')}</Trans>
        </div>
        <StagesWrapper>
          <div>
            <Trans>{t('pages.regional_overview.digital_traps.info_button.predictions.stages')}</Trans>
          </div>
          <ArrowRightIcon />
          <div>
            <Trans>{t('pages.regional_overview.digital_traps.info_button.predictions.stages_defined')}</Trans>
          </div>
        </StagesWrapper>
      </FlightEvolutionWrapper>
      <FlightStageTable />
    </Container>
  );
};

export default FlightPredictionTab;
